import {Stack} from 'shells/layout/stack/stack';

interface Props {
    children: React.ReactNode;
}

export function EditFieldsWrapper(props: Props) {
    return (
        <Stack isHorizontal={true} alignItems='start' spacing={24} wrap={true}>
            {props.children}
        </Stack>
    );
}
